"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsService = void 0;
class StatsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Update eligibility stats
     * @returns any Successful response
     * @throws ApiError
     */
    statsControllerUpdateEligibilityStats() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stats/eligibility',
        });
    }
    /**
     * Update channel labels stats
     * @returns any Successful response
     * @throws ApiError
     */
    statsControllerUpdateChannelLabelsStats() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stats/channel-labels',
        });
    }
    /**
     * Update deployment state changes stats
     * @returns any Successful response
     * @throws ApiError
     */
    statsControllerUpdateDeploymentStateChangesStats() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stats/deployment-state-changes',
        });
    }
    /**
     * Update email delivery stats
     * @returns any Successful response
     * @throws ApiError
     */
    statsControllerUpdateEmailDeliveryStats() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stats/email-delivery',
        });
    }
    /**
     * Update eligibility materialised views stats
     * @returns any Successful response
     * @throws ApiError
     */
    statsControllerUpdateEligibilityMaterialisedViewsStats() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stats/eligibility-refresh-views',
        });
    }
    /**
     * Update stats
     * @returns any Successful response
     * @throws ApiError
     */
    statsControllerUpdateStats() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stats/update-all',
        });
    }
    /**
     * Update all group stats
     * @returns any Successful response
     * @throws ApiError
     */
    statsControllerUpdateAllGroupStats() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stats/update-groups',
        });
    }
    /**
     * Update all campaign stats
     * @returns any Successful response
     * @throws ApiError
     */
    statsControllerUpdateAllCampaignStats() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stats/update-campaigns',
        });
    }
    /**
     * Update group stats
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    statsControllerUpdateGroupStats(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stats/group/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update campaign stats
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    statsControllerUpdateCampaignStats(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stats/campaign/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update deployments config stats
     * @returns any Successful response
     * @throws ApiError
     */
    statsControllerUpdateDeploymentsConfigStats() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stats/update-deployments-config-stats-manually',
        });
    }
    /**
     * Update deployment config stats
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    statsControllerUpdateDeploymentConfigStats(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stats/update-deployments-config-stats-manually/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update group config stats
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    statsControllerUpdateGroupConfigStats(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stats/update-group-config-stats-manually/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update group stats manually
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    statsControllerUpdateGroupStatsManually(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stats/update-group-stats-manually/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update campaign stats manually
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    statsControllerUpdateCampaignStatsManually(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stats/update-campaign-stats-manually/{id}',
            path: {
                'id': id,
            },
        });
    }
}
exports.StatsService = StatsService;
